import ReactFacebookLoginWithButton from "./facebook-with-button";

export const FacebookLoginButton = ReactFacebookLoginWithButton;
